<template>

  <v-container class="col-12">
    <!--    <v-card class="pa-4">-->
    <!--      <v-row class="mx-0" style="white-space: nowrap">-->
    <!--        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>-->
    <!--      </v-row>-->
    <!--    </v-card>-->
    <v-card class="col-12 pa-0 mt-0">

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 85px)`"
        fixed-header
        calculate-widths
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination"
        :items-per-page="options.perpage || -1"
        :footer-props="{'items-per-page-options': options.perpage ? ( options.perpage_list || [30, 60, 90]) : [-1]}"
        :class="{'report-dt': true}"
        style="z-index: 0; position: relative; width: 100%"
      >

        <template v-slot:item.to_convert="{ item, header }">
          <v-text-field
            class="data-table-finance-filter-textfield"
            v-model="item.to_convert"
            hide-details
          />
        </template>

        <template v-slot:item.converted="{ item, header }">
          {{ round((item.to_convert || 1) * item.amount, 4).toFixed(4) }}
        </template>

        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>


    <!--    <component-->
    <!--      is="default-report"-->
    <!--      :projectList="projectList"-->
    <!--      title="Currency Rate"-->
    <!--      :url="url"-->
    <!--      :headers="headers"-->
    <!--      :defaultParams="defaultParams"-->
    <!--      :options="options"-->
    <!--      :filters="filters || []"-->
    <!--    />-->
  </v-container>
</template>


<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';
</style>

<script>
  import { API } from '@/utils/api'
  import { map, filter, get, round } from 'lodash'

  export default {

    components: {
      DefaultReport: () => import('@/components/report/Default'),
    },
    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      }
    },

    data: () => ({
      loading: false,
      tableOptions: {},
      items: [],
      totalItems: 0,
      calculator: {
        currency_in: '',
        currency_out: '',
        date: '',
        amount: 0
      },
      url: '/reports/currency_rates.json',
      headers: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'Date', value: 'date' },
        { text: 'Currency In', value: 'currency_in' },
        { text: 'Currency Out', value: 'currency_out' },
        { text: 'Rate', value: 'amount' },
        { text: 'Amount', value: 'to_convert' },
        { text: 'Converted', value: 'converted' },
      ],
      filters: {
        date: { data: [], type: 'select' },
        currency_in: { data: [], type: 'select' },
        currency_out: { data: [], type: 'select' },
        amount: { data: [], type: 'text' },
        sell: { data: [], type: 'text' },
        buy: { data: [], type: 'text' },
      },
      options: { hideProjectSelector: true, pagination: true, perpage: 100, perpage_list: [ 50, 100, 200 ] },
      defaultParams: {}
    }),

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination) {
            this.search()
          }
        },
        deep: true,
      },
    },

    mounted () {
      this.search()
      // API.call('/two_fa/get_qr.json').then(resp => {
      //   this.qr = resp.qr
      // })
    },

    methods: {
      get,
      round,

      search: function () {
        if (this.loading == true) {
          return
        }
        this.loading = true
        try {
          if (this.options.accountType) {
            this.defaultParams.account_type = this.accountType
          }
          if (this.options.login) {
            this.defaultParams.login = this.login
          }

          API.call(this.url, {
            from: this.from,
            to: this.to,
            ...this.tableOptions,
            ...this.defaultParams
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }
            if (get(resp, 'totalRow', false)) {
              this.totalRow = resp.totalRow
            }
            if (get(resp, 'totalRows', false)) {
              this.totalRows = resp.totalRows
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      }
    }

  }
</script>
